module.exports = __webpack_public_path__ + "media/images/home/banner_bg___-4307ddb5adec062da759b150742f58d3.png";